import { Stack, Text, mq } from "@certn/cascadia-react";
import { css } from "@emotion/css";

export interface SubtitleProps {
  subtitle: React.ReactNode;
  description?: React.ReactNode;
  children?: React.ReactNode;
  testID?: string;
}

export function Subtitle({
  subtitle,
  description,
  children,
  testID = "subtitle",
}: SubtitleProps) {
  return (
    <div className={styles.outer} data-testid={testID}>
      <Stack gap="space-0" className={styles.subtitleAndDescription}>
        <Text style="global/heading-large">{subtitle}</Text>
        {description && (
          <Text style="global/body-secondary">{description}</Text>
        )}
      </Stack>
      {children}
    </div>
  );
}

const styles = {
  outer: css(
    {
      display: "flex",
      gap: "var(--space-4)",
      alignItems: "flex-start",
      alignSelf: "stretch",
    },
    mq({
      flexDirection: ["column", "row"],
    })
  ),
  subtitleAndDescription: css({
    flexGrow: 1,
  }),
};
